import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./social-share-footer.m.css";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Youtube from "../../atoms/social-media-icons/Youtube";
import Telegram from "../../atoms/social-media-icons/Telegram";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const list = [
    {
      Type: <Facebook color="black" height="16" width="16" isShareRequired={false} />,
      url: socials && socials.facebook ? socials.facebook.url : socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: <Twitter color="black" height="16" width="16" isShareRequired={false} />,
      url: socials && socials.twitter ? socials.twitter.url : socialLinks["twitter-url"],
      name: "Twitter"
    },
    {
      Type: <Youtube color="black" height="16" width="16" isShareRequired={false} />,
      url: socials && socials.youtube ? socials.youtube.url : socialLinks["youtube-url"],
      name: "Youtube"
    },
    {
      Type: <Telegram color="black" height="16" width="16" isShareRequired={false} />,
      url: socials && socials.telegram ? socials.telegram.url : socialLinks["telegram-url"],
      name: "Telegram"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list.map(({ url, Type, name }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(SocialShareIcons);
